/* src/app/user-default/dashboard/dashboard.component.scss */
.pw-notice {
  box-sizing: border-box;
  width: 100%;
  max-width: 600px;
  margin: 0 0 30px;
  padding: 20px 24px;
  background-color: white;
  border-left: 6px solid #80163a;
  border-radius: 18px;
  box-shadow: 17px 17px 17px 0px rgb(207, 207, 207);
}
@media only screen and (max-width: 767px) {
  .pw-notice {
    margin-left: auto;
    margin-right: auto;
    padding: 16px;
    box-shadow: 5px 5px 10px 0px rgb(207, 207, 207);
  }
}
.pw-notice-title {
  margin: 0 0 8px;
  font-family: halbfett, sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.3;
  color: #80163a;
}
.pw-notice-body {
  margin: 0 0 16px;
  font-family: leicht, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: #3a3a3a;
}
.pw-notice-btn {
  display: inline-block;
  min-width: 191px;
  padding: 0 20px;
  border-radius: 16px;
  background-color: #80163a;
  color: white;
  font-family: kraftig, sans-serif;
  font-size: 12px;
  line-height: 37px;
  text-align: center;
  text-decoration: none;
}
.pw-notice-btn:hover,
.pw-notice-btn:focus {
  background-color: #610222;
  color: white;
  text-decoration: none;
  box-shadow: 5px 5px 5px 0px rgb(207, 207, 207);
}
.pw-notice-btn:focus-visible {
  outline: 2px solid #363FAE;
  outline-offset: 2px;
}
/*# sourceMappingURL=dashboard.component-5IJABL4V.css.map */
